<template>
  <div class="manage-content page-card-wrapper">
    <div class="page-card-title">
      <span class="page-card-title-text">{{
        $t('text.network_utilisation')
      }}</span>
    </div>
    <div class="page-card-content">
      <div class="text-right mt-10">
        <el-checkbox v-model="openNotify" class="mr-20">{{
          $t('text.notify_me_when_nodes_offline')
        }}</el-checkbox>
        <el-checkbox v-model="zoomView">{{
          $t('text.zoom_in_chart')
        }}</el-checkbox>
      </div>
      <div v-if="loading" class="loading-chart-wrapper">
        <LoadingAnimation />
      </div>
      <div v-else>
        <div id="network-map" v-if="nodes.length"></div>
        <div v-else class="no-data min-h-300 mt-20 v-h-center wp-100">
          <b>{{ $t('text.no_nodes') }}</b>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DataSet, Network } from 'vis-network/standalone'
import ApiService from '@/services/ApiService.js'
import moment from 'moment'
import LoadingAnimation from '@/components/patients/charts/LoadingAnimation'
import swal from 'sweetalert'
export default {
  data() {
    return {
      openNotify: true,
      zoomView: false,
      loading: false,
      nodes: [],
      edges: [],
      chart: null,
      timer: null
      // nodes: new DataSet([
      //   {
      //     id: 1,
      //     size: 12,
      //     label: '<b>LAN</b>',
      //     image: require('../../assets/image/network-img/lan.png'),
      //     level: 0
      //   },
      //   {
      //     id: 2,
      //     label: '<b>Wi-Fi Infrastructure</b>',
      //     image: require('../../assets/image/network-img/wifi.png'),
      //     level: 0
      //   },
      //   {
      //     id: 3,
      //     label:
      //       '<b>Room A</b>\n AB:CD:EF\nPods: 3\nData: 750kb/s\nPacket less: 4%',
      //     image: require('../../assets/image/network-img/room.png'),
      //     level: 1
      //   },
      //   {
      //     id: 4,
      //     label:
      //       '<b>Mobile D3</b>\n AB:CD:EF\nPods: 3\nData: 750kb/s\nPacket less: 4%',
      //     image: require('../../assets/image/network-img/mobile.png'),
      //     level: 1
      //   },
      //   {
      //     id: 5,
      //     label:
      //       '<b>Room A2</b>\n AB:CD:EF\nPods: 3\nData: 750kb/s\nPacket less: 4%',
      //     image: require('../../assets/image/network-img/room.png'),
      //     level: 2
      //   },
      //   {
      //     id: 6,
      //     label:
      //       '<b>Room B1</b>\n AB:CD:EF\nPods: 3\nData: 750kb/s\nPacket less: 4%',
      //     image: require('../../assets/image/network-img/room-red.png'),
      //     level: 2
      //   },
      //   {
      //     id: 7,
      //     label:
      //       '<b>Room A3</b>\n AB:CD:EF\nPods: 3\nData: 750kb/s\nPacket less: 4%',
      //     image: require('../../assets/image/network-img/room.png'),
      //     level: 3
      //   },
      //   {
      //     id: 8,
      //     label:
      //       '<b>Room B1</b>\n AB:CD:EF\nPods: 3\nData: 750kb/s\nPacket less: 4%',
      //     image: require('../../assets/image/network-img/room.png'),
      //     level: 3
      //   },
      //   {
      //     id: 9,
      //     label:
      //       '<b>Room C</b>\n AB:CD:EF\nPods: 3\nData: 750kb/s\nPacket less: 4%',
      //     image: require('../../assets/image/network-img/room.png'),
      //     level: 1
      //   },
      //   {
      //     id: 10,
      //     label:
      //       '<b>Room C2</b>\n AB:CD:EF\nPods: 3\nData: 750kb/s\nPacket less: 4%',
      //     image: require('../../assets/image/network-img/room.png'),
      //     level: 2
      //   },
      //   {
      //     id: 11,
      //     label:
      //       '<b>Room D1</b>\n AB:CD:EF\nPods: 3\nData: 750kb/s\nPacket less: 4%',
      //     image: require('../../assets/image/network-img/room.png'),
      //     level: 2
      //   },
      //   {
      //     id: 12,
      //     label:
      //       '<b>Room C3</b>\n AB:CD:EF\nPods: 3\nData: 750kb/s\nPacket less: 4%',
      //     image: require('../../assets/image/network-img/room.png'),
      //     level: 3
      //   },
      //   {
      //     id: 13,
      //     label:
      //       '<b>Mobile E</b>\n AB:CD:EF\nPods: 3\nData: 750kb/s\nPacket less: 4%',
      //     image: require('../../assets/image/network-img/mobile-red.png'),
      //     level: 3
      //   },
      //   {
      //     id: 14,
      //     label:
      //       '<b>Room E4</b>\n AB:CD:EF\nPods: 3\nData: 750kb/s\nPacket less: 4%',
      //     image: require('../../assets/image/network-img/room.png'),
      //     level: 3
      //   },
      //   {
      //     id: 15,
      //     label:
      //       '<b>Mobile D1</b>\n AB:CD:EF\nPods: 3\nData: 750kb/s\nPacket less: 4%',
      //     image: require('../../assets/image/network-img/mobile.png'),
      //     level: 4
      //   },
      //   {
      //     id: 16,
      //     label:
      //       '<b>Room E2</b>\n AB:CD:EF\nPods: 3\nData: 750kb/s\nPacket less: <b><i>15%</i></b>',
      //     image: require('../../assets/image/network-img/room.png'),
      //     level: 4
      //   }
      // ]),
      // edges: new DataSet([
      //   { from: 1, to: 3, dashes: false },
      //   { from: 1, to: 4, dashes: false },
      //   { from: 3, to: 6, dashes: true, label: 'RSSI = 90' },
      //   {
      //     from: 3,
      //     to: 5,
      //     dashes: true,
      //     color: '#6DFF15',
      //     label: 'Secondary Connection\nRSSI = 90',
      //     font: { background: '#6DFF15' }
      //   },
      //   {
      //     from: 6,
      //     to: 8,
      //     dashes: true,
      //     color: '#888',
      //     label: 'Lost connection\n ',
      //     font: { color: 'red', vadjust: 15 },
      //     arrows: {
      //       middle: {
      //         enabled: true,
      //         type: 'image',
      //         src: require('../../assets/image/network-img/lost-connection.png'),
      //         imageWidth: 6,
      //         imageHeight: 12
      //       }
      //     }
      //   },
      //   {
      //     from: 6,
      //     to: 12,
      //     dashes: true,
      //     color: '#6DFF15',
      //     label: 'Secondary Connection\nRSSI = 90',
      //     font: { background: '#6DFF15' }
      //   },
      //   {
      //     from: 4,
      //     to: 10,
      //     dashes: true,
      //     color: '#6DFF15',
      //     label: 'Secondary Connection\nRSSI = 90',
      //     font: { background: '#6DFF15' }
      //   },
      //   { from: 9, to: 10, dashes: true, label: 'RSSI = 90' },
      //   { from: 9, to: 11, dashes: true, label: 'RSSI = 90' },
      //   {
      //     from: 10,
      //     to: 15,
      //     dashes: true,
      //     color: '#6DFF15',
      //     label: 'Secondary Connection\nRSSI = 90',
      //     font: { background: '#6DFF15' }
      //   },
      //   { from: 10, to: 12, dashes: true, label: 'RSSI = 90' },
      //   {
      //     from: 11,
      //     to: 13,
      //     dashes: true,
      //     color: '#888',
      //     label: 'Lost connection\n ',
      //     font: { color: 'red', vadjust: 15 },
      //     arrows: {
      //       middle: {
      //         enabled: true,
      //         type: 'image',
      //         src: require('../../assets/image/network-img/lost-connection.png'),
      //         imageWidth: 6,
      //         imageHeight: 12
      //       }
      //     }
      //   },
      //   {
      //     from: 13,
      //     to: 15,
      //     dashes: true,
      //     color: '#888',
      //     label: 'Lost connection\n ',
      //     font: { color: 'red', vadjust: 15 },
      //     arrows: {
      //       middle: {
      //         enabled: true,
      //         type: 'image',
      //         src: require('../../assets/image/network-img/lost-connection.png'),
      //         imageWidth: 6,
      //         imageHeight: 12
      //       }
      //     }
      //   },
      //   { from: 11, to: 14, dashes: true, label: 'RSSI = 90' },
      //   { from: 14, to: 16, dashes: true, label: 'RSSI = 90' },
      //   { from: 2, to: 9, dashes: true, label: 'RSSI = 90' },
      //   { from: 5, to: 7, dashes: true, label: 'RSSI = 90' }
      // ])
    }
  },
  components: {
    LoadingAnimation
  },
  mounted() {
    this.getData()
    this.timer = setInterval(this.getData, 180000)
  },
  watch: {
    zoomView() {
      this.initChart()
    },
    '$store.state.site.selectedSite.SiteId': function() {
      this.getData()
    },
    '$store.state.locale.currentLocale': function() {
      this.getData()
    }
  },
  methods: {
    getData() {
      if (
        !this.$store.state.site.selectedSite ||
        !this.$store.state.site.selectedSite.SiteId
      )
        return false
      this.loading = true
      if (this.chart) {
        this.chart.destroy()
      }
      this.nodes = this.edges = []
      this.getSiteNodes().then(() => {
        this.getNetworkUtilisation().then(() => {
          this.loading = false
          if (this.nodes.length) {
            this.$nextTick(() => {
              this.initChart()
            })
          }
        })
      })
    },
    async getSiteNodes() {
      await ApiService.getSiteNodes(
        this.$store.state.site.selectedSite.SiteId
      ).then(response => {
        if (response.data.success) {
          this.nodes = response.data.data
        } else {
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed'),
            text: response.data.msg
          })
        }
      })
    },
    async getNetworkUtilisation() {
      await ApiService.GetNetworkUtilisation(
        this.$store.state.site.selectedSite.SiteId
      ).then(response => {
        if (response.data.success) {
          this.nodes = this.nodes.map(node => {
            let nodeInMesh = response.data.data.filter(subItem => {
              return node.MacAddress === subItem.NodeMac
            })
            let lastSeen = ''
            if (nodeInMesh && nodeInMesh.length && nodeInMesh[0].LastSeen) {
              lastSeen = moment().diff(
                moment.utc(nodeInMesh[0].LastSeen),
                'seconds'
              )
            }
            // If lastSeen === null || lastSeen > 900 seconds, the node is offline
            let offline = !lastSeen || lastSeen > 900
            return {
              id: node.MacAddress,
              offline: offline,
              image: offline
                ? require('@/assets/image/network-img/room-red.png')
                : require('@/assets/image/network-img/room.png'),
              label: `<b>${node.AreaName}</b>\n ${node.MacAddress}\nPods: --\nData: 0kb/s\nPacket less: --`
            }
          })

          if (this.nodes.length) {
            let wifi = {
              id: 1,
              label: `<b>${this.$t('text.wifi_infrastructure')}</b>`,
              image: require('@/assets/image/network-img/wifi.png')
            }
            let lan = {
              id: 2,
              size: 12,
              label: `<b>${this.$t('text.lan')}</b>`,
              image: require('@/assets/image/network-img/lan.png')
            }
            this.nodes.unshift(wifi)
            this.nodes.unshift(lan)
          }

          response.data.data.forEach(edge => {
            // When a node connects multiple wifi routers, only one is displayed
            if (edge.MeshMode === 'Master' && edge.ParentMac) {
              let currentNodeExistWifi = this.edges.filter(item => {
                return item.to === edge.NodeMac && item.from === 1
              })
              if (currentNodeExistWifi.length > 0) return false
            }
            let edgeItem = {
              from: this.getFrom(edge),
              to: edge.NodeMac,
              dashes: edge.MeshMode !== 'Master',
              label: `${this.$t('text.rssi')} = ${edge.NodeRssi}`
            }
            if (this.getEdgeStatus(edgeItem)) {
              edgeItem.color = '#888'
              ;(edgeItem.label = `${this.$t('text.lost_connect')}\n `),
                (edgeItem.font = {
                  color: 'red',
                  vadjust: 25
                }),
                (edgeItem.arrows = {
                  middle: {
                    enabled: true,
                    type: 'image',
                    src: require('@/assets/image/network-img/lost-connection.png'),
                    imageWidth: 6,
                    imageHeight: 12
                  }
                })
            }
            this.edges.push(edgeItem)
          })
        } else {
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed'),
            text: response.data.msg
          })
        }
      })
    },
    getFrom(item) {
      if (item.MeshMode === 'Master') {
        if (item.ParentMac) {
          // from wifi
          return 1
        } else {
          // from lan
          return 2
        }
      } else {
        return item.ParentMac
      }
    },
    getEdgeStatus(edge) {
      let offline = false
      // If from or to is offline, the edge will be offline
      this.nodes.forEach(item => {
        if (
          (item.id === edge.from && item.offline) ||
          (item.id === edge.to && item.offline)
        ) {
          offline = true
        }
      })
      return offline
    },
    formatTime(num) {
      if (!num) return [0, 0, 0, 0]
      let day = Math.floor(num / 86400)
      let hour = Math.floor((num - day * 86400) / 3600)
      let minute = Math.floor((num - day * 86400 - hour * 3600) / 60)
      let second = num - day * 86400 - hour * 3600 - minute * 60
      let str = ''
      if (day) str = day + 'd '
      if (hour) str = str + hour + 'h '
      if (minute) str = str + minute + 'm '
      if (second) str = str + second + 's '
      return str
    },
    initChart() {
      let container = document.getElementById('network-map')
      let options = {
        width: '100%',
        height: '100%',
        layout: {
          randomSeed: 1
        },
        interaction: {
          zoomView: this.zoomView,
          hover: true,
          tooltipDelay: 0
        },
        nodes: {
          font: {
            multi: 'html',
            size: 11,
            vadjust: -5
          }
        },
        edges: {
          length: 250,
          font: {
            multi: 'html',
            size: 11
          }
        }
      }

      let connectEdge = this.edges.filter(item => {
        return item.from && item.to
      })
      if (!connectEdge.length) {
        options.layout.hierarchical = {
          levelSeparation: 195,
          nodeSpacing: 200,
          treeSpacing: 200,
          direction: 'UD',
          sortMethod: 'directed'
        }
      }
      let nodes = new DataSet(this.nodes)
      let edges = new DataSet(this.edges)
      let data = {
        nodes: nodes.map(item => {
          return {
            ...item,
            shape: 'image'
          }
        }),
        edges: edges
      }
      this.chart = new Network(container, data, options)
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
  // methods: {
  //   initChart() {
  //     let container = document.getElementById('network-map')
  //     let options = {
  //       layout: {
  //         randomSeed: 1,
  //         hierarchical: {
  //           levelSeparation: 195,
  //           nodeSpacing: 400,
  //           treeSpacing: 500,
  //           direction: 'UD',
  //           sortMethod: 'hubsize'
  //         }
  //       },
  //       interaction: {
  //         zoomView: this.zoomView,
  //         hover: true,
  //         tooltipDelay: 0
  //       },
  //       nodes: {
  //         font: {
  //           multi: 'html',
  //           size: 11,
  //           vadjust: -5,
  //           boldital: {
  //             color: 'red'
  //           }
  //         }
  //       },
  //       edges: {
  //         font: {
  //           multi: 'html',
  //           size: 11
  //         }
  //       }
  //     }
  //     let data = {
  //       nodes: this.nodes.map(item => {
  //         return {
  //           ...item,
  //           shape: 'image'
  //         }
  //       }),
  //       edges: this.edges
  //     }
  //     new Network(container, data, options)
  //   }
  // }
}
</script>
